import script from "./ContentCollapsibleListItems.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentCollapsibleListItems.vue?vue&type=script&setup=true&lang=js"

import "./ContentCollapsibleListItems.vue?vue&type=style&index=0&id=1f53f646&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f53f646"]])

export default __exports__